export default from './Modal';



// WEBPACK FOOTER //
// ./src/sharedComponents/Modal/index.js